import {MixedImage} from '@ui/images/mixed-image';
import clsx from 'clsx';
import React, {JSXElementConstructor} from 'react';
import {
  DatabaseNotification,
  DatabaseNotificationLine,
} from './database-notification';

interface LineProps {
  notification: DatabaseNotification;
  line: DatabaseNotificationLine;
  index: number;
  iconRenderer?: JSXElementConstructor<{icon: string}>;
}

export function Line({line, index, iconRenderer}: LineProps) {
  const Icon = iconRenderer || DefaultIconRenderer;
  const Element = line.action ? 'a' : 'div';

  // All content lines share one font/size and stack tightly right under one
  // another (e.g. the "…has replied to:" action line and the subject beneath
  // it). The timestamp is rendered separately by the list, below these lines.
  return (
    <Element
      className={clsx(
        'flex items-start gap-8 text-sm text-main',
        line.action && 'hover:underline',
        index > 0 && 'mt-2',
      )}
      href={line.action?.action}
      title={line.action?.label}
    >
      {line.icon && <Icon icon={line.icon} />}
      <div
        className="overflow-hidden"
        dangerouslySetInnerHTML={{__html: line.content}}
      />
    </Element>
  );
}

interface DefaultIconRendererProps {
  icon: string;
}
function DefaultIconRenderer({icon}: DefaultIconRendererProps) {
  return <MixedImage src={icon} />;
}
